import { createType } from 'reducers/utils/helpers';
import { generateTypes } from '../../utils/HttpReducerHelper';

const allClients = generateTypes('MONITOR', 'ALL_CLIENTS');
const client = generateTypes('MONITOR', 'CLIENT');
const updateClientNote = generateTypes('MONITOR', 'UPDATE_CLIENT_NOTE');
const updateClientManager = generateTypes('MONITOR', 'UPDATE_CLIENT_MANGER');
const updateClientPreview = createType('MONITOR', 'CLIENT_PPREVIEW');
const unassignTag = createType('MONITOR', 'UNASSIGN_TAG');
const assignTag = createType('MONITOR', 'ASSIGN_TAG');
const SET_WIZZARD_REDIRECT_CLIENT_ID =
  'platfi-ui-app/MONITOR_CONNECT_WIZZARD/SET_MONITOR_WIZZARD_CLIENT_ID';
const SET_MONITOR_STATUS_FILTERS = 'platfi-ui-app/MONITOR/SET_MONITOR_STATUS_FILTERS';
const SET_MONITOR_ARCHIVED_VIEW = 'platfi-ui-app/MONITOR/SET_MONITOR_ARCHIVED_VIEW';
const SET_MONITOR_PROPERTIES_FILTERS = 'platfi-ui-app/MONITOR/SET_MONITOR_PROPERTIES_FILTERS';
const SET_MONITOR_TAGS_FILTERS = 'platfi-ui-app/MONITOR/SET_MONITOR_TAGS_FILTERS';
const REMOVE_MONITOR_FILTERS = 'platfi-ui-app/MONITOR/REMOVE_MONITOR_FILTERS';
const CHANGE_CLIENTS_LOADING_STATE = 'platfi-ui-app/MONITOR/CHANGE_CLIENTS_LOADING_STATE';
const SET_CLIENT_GENERATED_AT = 'platfi-ui-app/MONITOR/SET_CLIENT_GENERATED_AT';
const SET_MONITOR_FILTER_BY_MANAGER = 'platfi-ui-app/MONITOR/SET_MONITOR_FILTER_BY_MANAGER';

export {
  allClients,
  client,
  updateClientNote,
  updateClientManager,
  updateClientPreview,
  unassignTag,
  assignTag,
  SET_WIZZARD_REDIRECT_CLIENT_ID,
  SET_MONITOR_PROPERTIES_FILTERS,
  SET_MONITOR_STATUS_FILTERS,
  SET_MONITOR_ARCHIVED_VIEW,
  SET_MONITOR_TAGS_FILTERS,
  REMOVE_MONITOR_FILTERS,
  CHANGE_CLIENTS_LOADING_STATE,
  SET_CLIENT_GENERATED_AT,
  SET_MONITOR_FILTER_BY_MANAGER,
};
